import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { ActivatedRoute, NavigationEnd, Router, Data } from '@angular/router';
import { Breadcrumb } from './breadcrumb.model';
import { Observable } from 'rxjs';


/**
 * class BreadcrumbComponent
 */
@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BreadcrumbComponent implements OnInit, AfterViewInit {

  newBreadCrumbs: { label: string; url: string; }[];
  // rotaAtual$: Observable<any>;
  rotaAtual: string | null = null;
  breadcrumb$: Observable<any>;

  eixo: {
    label: string;
    url: string;
    id: number;
  };

  area: {
    label: string;
    url: string;
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.breadcrumb$ = this.router.events.pipe(
      filter((event: NavigationEnd) => event instanceof NavigationEnd), distinctUntilChanged(),
      map((event) => {
        if ((event.url === '/' || event.url === '/#eixo-tecnologico')) {
          this.rotaAtual = event.url;
        } else {
          this.rotaAtual = null;
        }
        return this.buildBreadCrumb(this.activatedRoute);
      }),
    );
  }

  buildBreadCrumb(route: ActivatedRoute, url: string = '', breadcrumbs: Array<Breadcrumb> = []
  ): Array<Breadcrumb> {
    // caso nenhuma rota esteja disponível nós estamos no caminho raiz
    const label = route.routeConfig ? this.createLabel(route.snapshot.data) : 'Principal';
    const path = route.routeConfig ? route.routeConfig.path : '/';
    // no route.Config o caminho completo não está disponível
    const nextUrl = `${url}${path}`;
    const breadcrumb = {
      label,
      url: nextUrl,
    };

    if (nextUrl && nextUrl.startsWith('/cursosarea')) {
      const data = route.snapshot.data;
      this.eixo = {
        label: data.eixo.nome,
        url: '/eixo-tecnologico',
        id: data.eixo.id,
      };

      this.newBreadCrumbs =
        breadcrumb.label !== null && breadcrumb.label !== ''
          ? [...breadcrumbs, this.eixo, breadcrumb]
          : [...breadcrumbs];
    }
    // if (label && label.startsWith('Técnico')) {
    else if (nextUrl && nextUrl.startsWith('/cursoscurso')) {
      const eixo = route.snapshot.data.eixos.find(
        (el: any) => el.id === route.snapshot.data.curso.eixoTecnologicoCnctId,
      );

      this.eixo = {
        label: eixo.nome,
        url: '/eixo-tecnologico',
        id: eixo.id,
      };

      this.newBreadCrumbs =
        !!breadcrumb.label
          ? [...breadcrumbs, this.eixo, breadcrumb]
          : [...breadcrumbs];
    } else if (label && label.startsWith('Eixo')) {
      const eixo = route.snapshot.data.eixo;

      this.eixo = {
        label: eixo.nome,
        url: '/eixo-tecnologico',
        id: eixo.id,
      };

      this.newBreadCrumbs =
        !!breadcrumb.label
          ? [...breadcrumbs, this.eixo]
          : [...breadcrumbs];

    } else {
      this.newBreadCrumbs =
        !!breadcrumb.label
          ? [...breadcrumbs, breadcrumb]
          : [...breadcrumbs];
    }

    if (route.firstChild) {
      // caso não estejamos no caminho atual ainda,
      // não haverá mais "crianças" para observar, para construir o breadcrumb
      return this.buildBreadCrumb(route.firstChild, nextUrl, this.newBreadCrumbs);
    }
    // verificando se a página atual é a página principal, caso seja
    // o breadcrumb não aparecerá na tela
    return this.newBreadCrumbs;
  }

  createLabel(data: Data): string {
    if (data.breadcrumb) {
      if (data.breadcrumb.startsWith('{{')) {
        const [key, value] = data.breadcrumb.replace('{{', '').replace('}}', '').split('.');
        return data[key][value];
      }
      return data.breadcrumb;
    }
    return null;
  }

  ngAfterViewInit() {
    // Controla o ciclo de detecção
    this.cdr.detectChanges();
  }
}
